import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { getAddPhoneNumberCallState } from 'src/app/pages/add-phone-number/state/add-phone-number.selectors';
import { ExtensionDetailView } from 'src/app/pages/extension-details/models/extension-detail-view.model';
import { PhoneNumberDetailView } from 'src/app/pages/phone-number-details/models/phone-number-detail-view.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-account-phone-numbers',
    templateUrl: './add-account-phone-numbers.component.html',
    standalone: false
})
export class AddAccountPhoneNumberComponent implements FormComponent, OnDestroy {
   callState$: Observable<CallState>;

   form: UntypedFormGroup;

   phoneNumber: PhoneNumberDetailView;

   phoneNumbersToSave: PhoneNumberDetailView[] = [];

   newPhoneNumber: PhoneNumberDetailView = {
      phoneNumberId: 0,
   };

   existingPhoneNumbers: PhoneNumberDetailView[];

   existingExtensions: ExtensionDetailView[] | null;

   isNew: boolean;

   private destroyed$ = new Subject<void>();

   constructor(
      public dialogRef: MatDialogRef<AddAccountPhoneNumberComponent>,
      protected store: Store,
      @Inject(MAT_DIALOG_DATA) public data,
      private fb: UntypedFormBuilder
   ) {
      this.callState$ = this.store.pipe(select(getAddPhoneNumberCallState));
      this.phoneNumber = {
         ...data.phoneNumber,
      };
      this.existingPhoneNumbers = data.existingPhoneNumbers;
      this.existingExtensions = data.existingExtensions;
      this.isNew = data.isNew;
      this.form = this.fb.group({
         phoneNumber: this.fb.control(null),
         displayName: this.fb.control(null),
         routeTo: this.fb.control(null),
         providerId: this.fb.control(null),
         isActive: this.fb.control(true),
         isPorted: this.fb.control(null),
         datePorted: this.fb.control(null),
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
   onCancel() {
      this.dialogRef.close(this.phoneNumbersToSave);
   }

   onSubmit(submitEvent: { phoneNumber: PhoneNumberDetailView; continuous?: boolean }) {
      if (this.form.valid) {
         this.phoneNumbersToSave.push(submitEvent.phoneNumber);
         this.existingPhoneNumbers.push(submitEvent.phoneNumber);
         if (!submitEvent.continuous) {
            this.dialogRef.close(this.phoneNumbersToSave);
         } else {
            this.phoneNumber = this.newPhoneNumber;
            this.resetForm();
         }
      }
   }

   private resetForm() {
      this.form.reset();
      this.form.get('phoneNumber')?.setValue(null);
   }
}
